import { APP_TIME_ZONE } from '../format.js';

/**
 * The shop's calendar, as `<input type="date">` wants it.
 *
 * A day in this module is a shop-timezone `YYYY-MM-DD` string and never a timestamp — a shop that
 * closes at 11pm files that evening's work under that evening's date, and a UTC instant would file
 * it under tomorrow. `en-CA` is used for the formatting because its numeric date format IS
 * `YYYY-MM-DD`; the locale is a mechanism here, not a language choice.
 */

function shopDayParts(now: Date): { year: string; month: string; day: string } {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: APP_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);
  const get = (type: string): string => parts.find((part) => part.type === type)?.value ?? '';
  return { year: get('year'), month: get('month'), day: get('day') };
}

/** Today in the shop's timezone. */
export function todayInputValue(now = new Date()): string {
  const { year, month, day } = shopDayParts(now);
  return `${year}-${month}-${day}`;
}

/** The first of the month today falls in — where a person's history opens. */
export function monthStartInputValue(now = new Date()): string {
  const { year, month } = shopDayParts(now);
  return `${year}-${month}-01`;
}
